import { getClient } from "./client";
import type {
  ApiAvailableEvent,
  ApiEvent,
  ApiGamePlayer,
  ApiGamePrize,
  ApiGameSponsor,
  ApiMatchup,
  ApiTeam,
  GameStatus,
} from "./shared";

export type ApiGameDetails = {
  id: string;

  tokensGiven: number;
  availableEvents: ApiAvailableEvent[];
  gamePlayers: ApiGamePlayer[];
  gameSponsor: null | ApiGameSponsor;
  prizes: ApiGamePrize[];
  team: ApiTeam;

  /** Full UTC */
  timestamp: string;
  status: GameStatus;
} & (
  | { typeEvent: null; typeMatchup: ApiMatchup }
  | { typeEvent: ApiEvent; typeMatchup: null }
);

export const getGameById = (gameId: string) =>
  getClient().get(`/api/games/${gameId}`).json<ApiGameDetails>();
